import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <a
            href="#top"
            className="flex items-center gap-3 cursor-pointer"
          >
            <span className="font-display text-3xl md:text-4xl leading-none text-primary-500">
              17
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-base md:text-lg font-bold tracking-wide text-foreground-950">
                17黑料网
              </span>
              <span className="mt-1 text-[10px] md:text-[11px] tracking-[0.32em] text-foreground-500">
                档案 · 整理 · 讨论
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#tags"
              className="hidden md:inline-flex items-center gap-2 rounded-md bg-foreground-950 px-5 py-2.5 text-sm text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-line text-base" />
              查看槽点汇总
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="md:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-900 cursor-pointer"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-6 pt-4">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-200 py-3.5 text-sm text-foreground-800 cursor-pointer"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400" />
              </a>
            ))}
          </nav>
          <a
            href="#tags"
            onClick={() => setMenuOpen(false)}
            className="mt-5 flex items-center justify-center gap-2 rounded-md bg-foreground-950 px-5 py-3 text-sm text-background-50 cursor-pointer"
          >
            <i className="ri-fire-line text-base" />
            查看槽点汇总
          </a>
        </div>
      )}
    </header>
  );
}